<template>
  <div class="container">
    <div class="jumbotron m-3">
      <h2 class="mb-5 text-center">Lista de Notícias</h2>
      <v-container>
        <v-data-table
          :headers="headers"
          :items="posts"
          :page.sync="page"
          :items-per-page="5"
          hide-default-footer
          class="elevation-1"
          @page-count="pageCount = $event"
          :loading="loading"
          :sort-by="['dataPublicacao']"
          :sort-desc="[true]"
          loading-text="Carregando, aguarde..."
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-text-field
                v-model="search"
                append-icon="fas fa-search"
                label="Pesquisar..."
                class="mr-5"
                single-line
                hide-details
              ></v-text-field>
              <router-link to="/criar">
                <v-btn color="primary" class="mb-2">Cadastrar</v-btn>
              </router-link>
            </v-toolbar>
          </template>
          <template v-slot:item.imagens="{ item }">
            <v-img :src="item.imagem" width="50"></v-img>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editarPost(item.postId)">mdi-pencil</v-icon>
            <v-icon
              small
              @click="postId = item.postId"
              data-toggle="modal"
              data-target="#deletarNoticia"
            >mdi-delete</v-icon>
          </template>
          <template slot="no-data">
            <v-alert
              :value="true"
            >Não existem notícias, clique no botão cadastrar e crie a primeira notícia!</v-alert>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </v-container>
    </div>
    <div
      class="modal fade"
      id="deletarNoticia"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Deletar Notícia</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">Você tem certeza que deseja deletar está notícia?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Não</button>
            <button
              type="button"
              class="btn btn-danger"
              v-on:click="deletarNoticia(postId)"
              data-dismiss="modal"
            >Sim</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import moment from "moment";
import router from "../router";

import EventBus from "./EventBus";

export default {
  name: "ListarPosts",
  data() {
    const token = localStorage.usertoken;

    return {
      page: 1,
      pageCount: 0,
      search: "",
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "postId",
        },
        { text: "Imagem", value: "imagens", sortable: false },
        { text: "Título", value: "titulo" },
        { text: "Assunto", value: "assunto" },
        { text: "Categoria", value: "categoria" },
        { text: "Data da Publicação", value: "dataPublicacao" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      postId: 0,
      search: "",
      pageNumber: 0,
      posts: [],
      categorias: [],
      token: token,
      loading: true,
    };
  },
  mounted() {
    this.getCategorias();
    this.getPosts();

    EventBus.$on("noticia", (status) => {
      this.getPosts();
    });
  },
  methods: {
    editarPost(id) {
      router.push({ path: `/editar/${id}` }).catch(()=>{});
    },
    getCategorias() {
      axios.get("https://www.sabios.net.br/api/categoria").then(
        (rs) => {
          this.categorias = rs.data;
        },
        (err) => console.log("Error: " + err)
      );
    },
    getPosts() {
      this.loading = true;
      this.posts = new Array();
      axios.get("https://www.sabios.net.br/api/post").then(
        (rs) => {
          rs.data.forEach((post) => {
            const byteString = atob(post.imagem.split(",")[1]);
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i += 1) {
              ia[i] = byteString.charCodeAt(i);
            }
            const newBlob = new Blob([ab], {
              type: "image/jpeg",
            });

            post.imagem = window.URL.createObjectURL(newBlob);

            let categoria = this.categorias.find(
              (x) => x.categoriaId == post.categoriaId
            );

            if (categoria) post.categoria = categoria.titulo;

            if (post.dataPublicacao)
              post.dataPublicacao = moment(
                post.dataPublicacao,
                "YYYY-MM-DD"
              ).format("DD/MM/YYYY");
          });

          this.posts = rs.data;
          this.loading = false;
        },
        (err) => console.log("Error: " + err)
      );
    },
    deletarNoticia(postId) {
      axios.delete(`/api/post/${postId}`).then(
        (rs) => {
          this.getPosts();
        },
        (err) => console.log("Error: " + err)
      );
    },
    emitMethod() {
      EventBus.$emit("logged-in", "expirado");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ListarPosts.vue